import React from "react";
import Dante, {
    DanteTooltipConfig,
    DanteInlineTooltipConfig,
    DanteAnchorPopoverConfig,
    DanteImagePopoverConfig,
    Icons,
    ImageBlockConfig,
    EmbedBlockConfig,
    PlaceholderBlockConfig,
    VideoBlockConfig,
    // @ts-ignore
} from "../../../../../node_modules/Dante2/package/umd/Dante";
import { Parts } from "../../Write";
import {
    convertFromRaw,
    convertToRaw,
    EditorState,
    convertFromHTML,
    ContentState,
    RawDraftContentState,
} from "draft-js";
import { useState } from "react";
import { useEffect } from "react";
import Loader from "react-spinners/RingLoader";
import { convertToHTML } from "draft-convert";
import config from "../../../../config/apiConfig";
import Cookies from "js-cookie";

type Props = {
    parts: Parts;
    setParts: (arg: Parts) => void;
};

const Editor: React.FC<Props> = (props) => {
    const [content, setContent] = useState<RawDraftContentState>();
    const [loaded, setLoaded] = useState(false);
    const [lastImg, setLastImg] = useState("");

    let options: { [key: string]: any } = {
        api_key: "86c28a410a104c8bb58848733c82f840",
    };
    const widgetConfiguration = [
        ImageBlockConfig({
            title: "add an image",
            icon: Icons.image,
            type: "image",
            editable: true,
            renderable: true,
            breakOnContinuous: true,
            wrapper_class: "graf graf--figure",
            selected_class: "is-selected is-mediaFocused",
            selectedFn: (block: any) => {
                const { direction } = block.getData().toJS();
                switch (direction) {
                    case "left":
                        return "graf--layoutOutsetLeft";
                    case "center":
                        return "";
                    case "wide":
                        return "sectionLayout--fullWidth";
                    case "fill":
                        return "graf--layoutFillWidth";
                    default:
                        return "";
                }
            },
            widget_options: {
                displayOnInlineTooltip: true,
                insertion: "upload",
                insert_block: "image",
            },
            options: {
                upload_url:
                    config.BASE_URL +
                    "/v1/put/image/upload?token=" +
                    config.token +
                    "&session-token=" +
                    Cookies.get("token"),
                // upload_headers: {
                //     "token": config.token,
                //     "session-token": Cookies.get("token"),
                // },
                upload_formName: "cover_image",
                upload_callback: (result: any, img: any) => {
                    img.image_tag.src = result.data.data;
                    setLastImg(result.data.data);
                },
            },
        }),
        EmbedBlockConfig({
            icon: Icons.embed,
            title: "insert embed",
            type: "embed",
            editable: true,
            renderable: true,
            breakOnContinuous: true,
            wrapper_class: "graf graf--mixtapeEmbed",
            selected_class: "is-selected is-mediaFocused",
            widget_options: {
                displayOnInlineTooltip: true,
                insertion: "placeholder",
                insert_block: "embed",
            },
            options: {
                endpoint: `//api.embed.ly/1/extract?key=86c28a410a104c8bb58848733c82f840&url=`,
                placeholder:
                    "Paste a link to embed content from another site (e.g. Twitter) and press Enter",
            },
        }),
        PlaceholderBlockConfig(),
        VideoBlockConfig({
            icon: Icons.video,
            title: "insert video",
            editable: true,
            type: "video",
            renderable: true,
            breakOnContinuous: true,
            wrapper_class: "graf--figure graf--iframe",
            selected_class: " is-selected is-mediaFocused",
            widget_options: {
                displayOnInlineTooltip: true,
                insertion: "placeholder",
                insert_block: "video",
            },
            options: {
                endpoint: `//api.embed.ly/1/oembed?key=86c28a410a104c8bb58848733c82f840&url=`,
                placeholder:
                    "Paste a YouTube, Vine, Vimeo, or other video link, and press Enter",
                caption: "Type caption for embed (optional)",
            },
        }),
    ];

    const tooltipConfiguration = [
        DanteTooltipConfig({
            ref: "insert_tooltip",
            displayOnSelection: true,
            selectionElements: [
                "unstyled",
                "blockquote",
                "ordered-list",
                "unordered-list",
                "unordered-list-item",
                "ordered-list-item",
                "header-one",
                "header-two",
                "header-three",
                "header-four",
            ],
            widget_options: {
                block_types: [
                    {
                        label: "h2",
                        style: "header-one",
                        type: "block",
                        icon: Icons.h2,
                    },
                    {
                        label: "h3",
                        style: "header-two",
                        type: "block",
                        icon: Icons.h3,
                    },
                    {
                        label: "h4",
                        style: "header-three",
                        type: "block",
                        icon: Icons.h4,
                    },
                    {
                        label: "blockquote",
                        style: "blockquote",
                        type: "block",
                        icon: Icons.blockquote,
                    },
                    {
                        label: "insertunorderedlist",
                        style: "unordered-list-item",
                        type: "block",
                        icon: Icons.insertunorderedlist,
                    },
                    {
                        label: "insertorderedlist",
                        style: "ordered-list-item",
                        type: "block",
                        icon: Icons.insertorderedlist,
                    },
                    {
                        label: "code",
                        style: "code-block",
                        type: "block",
                        icon: Icons.code,
                    },
                    {
                        label: "bold",
                        style: "BOLD",
                        type: "inline",
                        icon: Icons.bold,
                    },
                    {
                        label: "italic",
                        style: "ITALIC",
                        type: "inline",
                        icon: Icons.italic,
                    },
                ],
            },
        }),
        DanteInlineTooltipConfig({
            ref: "add_tooltip",
        }),
    ];

    const xhrConfiguration = {
        before_handler: null,
        success_handler: null,
        error_handler: null,
    };

    const storageConfiguration = {
        url: null,
        method: "POST",
        success_handler: null,
        failure_handler: null,
        interval: 1500,
    };

    const wrapperConfiguration = [
        { className: "graf--p", block: "unstyled" },
        { className: "graf--h2", block: "header-one" },
        { className: "graf--h3", block: "header-two" },
        { className: "graf--h4", block: "header-three" },
        { className: "graf--blockquote", block: "blockquote" },
        {
            className: "graf--insertunorderedlist",
            block: "unordered-list-item",
        },
        { className: "graf--insertorderedlist", block: "ordered-list-item" },
        { className: "graf--code", block: "code-block" },
        { className: "graf--bold", block: "BOLD" },
        { className: "graf--italic", block: "ITALIC" },
    ];

    const blocksConfiguration = [
        "unstyled",
        "blockquote",
        "ordered-list",
        "unordered-list",
        "unordered-list-item",
        "ordered-list-item",
        "code-block",
    ];

    const commandsConfiguration = {
        "alt-shift": [{ key: 65, cmd: "add-new-block" }],
        "alt-cmd": [
            { key: 49, cmd: "toggle_block:header-one" },
            { key: 50, cmd: "toggle_block:header-two" },
            { key: 53, cmd: "toggle_block:blockquote" },
        ],
        cmd: [
            { key: 66, cmd: "toggle_inline:BOLD" },
            { key: 73, cmd: "toggle_inline:ITALIC" },
            { key: 75, cmd: "insert:link" },
        ],
    };

    const characterConvertConfiguration = {
        "> ": "blockquote",
        "*.": "unordered-list-item",
        "* ": "unordered-list-item",
        "- ": "unordered-list-item",
        "1.": "ordered-list-item",
        "# ": "header-one",
        "##": "header-two",
        "==": "unstyled",
        "` ": "code-block",
    };

    // useEffect(() => {
    //     setBody(props.parts.body ?? "<p></p>");
    // }, [props.parts.body === undefined, props.parts.id]);

    useEffect(() => {
        const state = props.parts.body.raw;
        setLoaded(false);
        if (!!state) {
            setContent(state);
        } else {
            setContent(undefined);
        }
        setTimeout(() => setLoaded(true), 500);
    }, [props.parts.body.raw]);

    if (!loaded) return <div></div>;

    return (
        <Dante
            el={"app"}
            content={content}
            read_only={false}
            spellcheck={false}
            title_placeholder={"Title"}
            body_placeholder={"Write your story"}
            widgets={widgetConfiguration}
            tooltips={tooltipConfiguration}
            xhr={xhrConfiguration}
            data_storage={storageConfiguration}
            default_wrappers={wrapperConfiguration}
            continuousBlocks={blocksConfiguration}
            key_commands={commandsConfiguration}
            character_convert_mapping={characterConvertConfiguration}
            onChange={(editor: any) => {
                let content = editor.getEditorState().getCurrentContent();
                const raw = convertToRaw(content);
                raw.blocks.forEach((b) => {
                    if (b.type === "image" && !!b.data && !b.data.url) {
                        b.data.url = lastImg;
                    }
                });
                content = convertFromRaw(raw);
                const html = convertToHTML({
                    blockToHTML: (block) => {
                        if (block.type === "placeholder") {
                            return <p />;
                        }
                        if (block.type === "video") {
                            let html: string | undefined;
                            if (!!block.data?.embed_data)
                                html = JSON.parse(
                                    JSON.stringify(block.data?.embed_data)
                                )["html"];
                            return html ?? <iframe />;
                        }
                        if (block.type === "embed") {
                            let html: string | undefined;
                            if (!!block.data?.embed_data) {
                                const embedData = JSON.parse(
                                    JSON.stringify(block.data?.embed_data)
                                );
                                if (!!embedData.media?.html) {
                                    html = embedData.media.html;
                                } else {
                                    html = embedData.content;
                                }
                            }
                            return html ?? <div />;
                        }
                        if (block.type === "code-block") {
                            return <code />;
                        }
                        if (block.type === "image") {
                            return <img src={block.data?.url ?? ""} />;
                        }
                    },
                })(content);
                const body = { raw, html };
                props.setParts({ ...props.parts, body });
            }}
        />
    );
};

export default Editor;
